// CartContext.jsx
import React, { createContext, useEffect, useMemo, useState } from "react";

export const CartContext = createContext();

const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem("cart");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (item) => {
    setCartItems((prev) => {
      const quantityToAdd = Number(item.quantity || 1);
      const maxQty = Number(item.stock ?? 9999);

      const idx = prev.findIndex(
        (p) => p.id === item.id && p.selectedColor === item.selectedColor
      );

      if (idx !== -1) {
        const updated = [...prev];
        const currentQty = Number(updated[idx].quantity || 1);
        const nextQty = clamp(currentQty + quantityToAdd, 1, maxQty);
        updated[idx] = { ...updated[idx], quantity: nextQty };
        return updated;
      }

      const q = clamp(quantityToAdd, 1, maxQty);
      return [...prev, { ...item, quantity: q }];
    });
  };

  const removeFromCart = (id, selectedColor) => {
    setCartItems((prev) =>
      prev.filter((item) => item.id !== id || item.selectedColor !== selectedColor)
    );
  };

  const updateQuantity = (id, selectedColor, newQuantity) => {
    setCartItems((prev) =>
      prev.map((item) => {
        if (item.id === id && item.selectedColor === selectedColor) {
          const maxQty = Number(item.stock ?? 9999);
          const q = clamp(Number(newQuantity || 1), 1, maxQty);
          return { ...item, quantity: q };
        }
        return item;
      })
    );
  };

  const value = useMemo(
    () => ({ cartItems, addToCart, removeFromCart, updateQuantity, setCartItems }),
    [cartItems]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
